
import React, { useState } from 'react'

export const PhoneNumberCmp = ({ addPhonenumber }) => {
  const [phonenumber, setPhonenumber] = useState('')

  function onChangeInput(event) {
    setPhonenumber(event.target.value)
  }

  function handlerContinuar(phonenumber) {
 
    addPhonenumber(phonenumber)
  }

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handlerContinuar(event.target.value);
    }
  };

  return (
    <div style={{ marginTop: '-50%' }}>
      <div className='mb-10'>
        <h1 className="text-2xl font-bold">Cual es tu número de teléfono?</h1>
        <p>Te contactaremos por whatsapp,<p className='font-bold'>fijese bien en el número</p></p>
      </div>

      <div className="flex flex-col items-center">
        <div className="indicator">
          <span className="indicator-item badge badge-primary">Cuba</span>
          <input onKeyDown={handleKeyPress} type="tel" inputMode="tel" className="input input-bordered input-lg w-full max-w-xs" placeholder="Ingrese su numero de telefono..." value={phonenumber} onChange={onChangeInput} />
        </div>
        <button disabled={phonenumber ? false : true} className="btn btn-primary mt-5" onClick={() => handlerContinuar(phonenumber)}>Continuar</button>
      </div>
    </div>
  )
}